<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Shift Complete</ion-title>
  </ion-toolbar>
  <div class="main_wrapper ion-padding main_wrapper--custom">
    <div v-if="userRole == 'locum' && isAustralia" class="alert-outer">
      <div class="alert_message_shift" v-if="user.billing.bankAccountName == null ||
          user.billing.bankAccountNumber == null ||
          user.billing.bankBsb == null
          ">
        Please note that your bank account details are missing and you will not be
        paid for the shift unless you provide one.
      </div>
      <div class="alert_message_shift" v-else-if="user.bankVerification.verified == 0">
        Thank you for providing your bank details. The next step is to verify your
        bank account.
      </div>
    </div>
    <div class="container">
    <el-form class="shift_form full_page" :model="formsData.confirmForm" :rules="formsData.confirmForm.rules"
      :ref="(el) => (formsData.confirmForm.ref = el)" :label-position="'top'" @submit.prevent="submit('confirmForm')">
      <div class="user_info">
        <div class="image_text_comp" @click="userInfoModalOpen(shift[userRoleReverse])">
          <div class="image_wrapper">
            <el-avatar :size="'small'" :shape="userRole == 'locum' ? 'square' : 'circle'"
              :src="shift[userRoleReverse].image" v-if="shift[userRoleReverse].image" />
            <el-avatar :size="'small'" :shape="userRole == 'locum' ? 'square' : 'circle'" icon="el-icon-user-solid"
              v-else></el-avatar>
          </div>
          <div class="text_wrapper">
            <div class="main_text">{{ shift[userRoleReverse].name }}</div>
            <div class="additional_text">
              {{
        userRole == "locum"
          ? $filters.addressText(shift.pharmacy.address)
          : formatAhpraDisplay(shift.locum)
      }}
            </div>
          </div>
        </div>
      </div>
      <div class="single-shift-time">
        <div class="form_text">
          <div class="title">
            <!-- <div class="shift_date">
              {{ $moment(shift.date, "YYYY/MM/DD").format("dddd, D MMMM") }}
            </div> -->
            
            <span class="weekday">{{ $moment(shift.date, "YYYY/MM/DD").format('dddd') }}</span>
            <span class="date" v-if="isAustralia">{{ $moment(shift.date, "YYYY/MM/DD").format('D MMM YYYY') }}</span>
            <span class="date" v-else>{{ $moment(shift.date, "YYYY/MM/DD").format('MMM DD YYYY') }}</span>
          </div>
          <div class="text_note">
            <span v-if="userRole == 'locum'"> Check your shift hours </span>
            <span v-else> Submitted shift hours </span>
          </div>
        </div>
        <el-form-item class="shift_time" prop="shiftTime">
          <ion-item>
            <ion-datetime v-model="formsData.confirmForm.shiftTime.value.timeStart" display-format="h:mm A"
              minute-values="0,15,30,45" placeholder="Start Time"
              @ionChange="checkFormValidation('confirmForm', true, 'shiftTime')"
              :disabled="userRole == 'pharmacy'"></ion-datetime>
          </ion-item>
          <ion-item>
            <ion-datetime v-model="formsData.confirmForm.shiftTime.value.timeEnd" display-format="h:mm A"
              minute-values="0,15,30,45" placeholder="End Time"
              @ionChange="checkFormValidation('confirmForm', true, 'shiftTime')"
              :disabled="userRole == 'pharmacy'"></ion-datetime>
          </ion-item>
        </el-form-item>
      </div>
      <template v-if="userRole == 'pharmacy'">

        <el-form-item class="shift_break pharmacy" prop="shiftBreak">
          <div class="shift_break_append">Break Time</div>
          <ion-item>
            <span class="shift_break_prepend">{{ formatDurationDisplay(formsData.confirmForm.shiftBreak.time) }}</span>
          </ion-item>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item class="shift_break_checkbox mb-1">
          <div class="mb-3 alert-info"
            v-if="messageIfCannotTakePartInPND !== false && !shift.shiftBookedAsInternalStaff && isAustralia">
            {{ messageIfCannotTakePartInPND }}
          </div>
          <!-- <el-form-item class="shift_break_checkbox" v-if="payNextDayEnabled">
            <el-checkbox
              v-if="
                checkPayNextDayForThisLocum === true && isBankVerified === 1
              "
              v-model="formsData.confirmForm.isPayNextDay.value"
              class="mb-2"
            >
              Enable Pay Next Day
            </el-checkbox>

            <el-tooltip
              v-else
              :content="messageIfCannotTakePartInPND"
              placement="top"
            >
              <el-checkbox
                v-model="formsData.confirmForm.isPayNextDay.value"
                class="mb-2"
                :disabled="
                  checkPayNextDayForThisLocum === false || isBankVerified === 0
                "
              >
                Enable Pay Next Day
              </el-checkbox>
            </el-tooltip>
          </el-form-item> -->
          <el-checkbox v-model="formsData.confirmForm.shiftBreak.active">Add Break</el-checkbox>
        </el-form-item>
        <el-form-item class="shift_break" prop="shiftBreak" v-if="formsData.confirmForm.shiftBreak.active">
          <div class="shift_break_append">How long?</div>
          <ion-item class="break_duration_item">
            <span class="shift_break_prepend">{{ formatDurationDisplay(formsData.confirmForm.shiftBreak.time) }}</span>
            <ion-datetime class="break_duration_picker" v-model="formsData.confirmForm.shiftBreak.time" display-format="H:mm" picker-format="H - mm"
              :hour-values="formsData.confirmForm.shiftBreak.hoursValue()" @ionChange="shiftBreakChange"
              :disabled="!formsData.confirmForm.shiftBreak.hoursValue().length"></ion-datetime>
          </ion-item>
        </el-form-item>
      </template>
      <div class="shift_form_footer">
        <div class="form_text">
          <div class="text_note">
            <span v-if="userRole == 'pharmacy'">Shift hours will be confirmed automatically after 48 hours.</span>
            <span v-else>Please ensure that your work hours and break times are accurate
              as incorrect information may delay payments.</span>
          </div>
        </div>
        <div class="total_wrapper" v-if="userRole == 'pharmacy'">


          <template v-if="!shift.shiftBookedAsInternalStaff">



            <template v-if="superEnable == 1 && !shift.shiftBookedAsInternalStaff">
              <div class="total_item result">
                <span class="total_text" v-if="isAustralia">Pay Rate <span v-if="billinAccountType !== 1"> Excluding Super</span></span>
                <span class="total_text" v-else>Pay Rate</span>
                <span class="total_value" >{{ formatCurrencyConvert(excludingSuperPerHourRate) }}</span>
              </div>
              <div class="total_item result" v-if="isAustralia">
                <span class="total_text">Super ({{ formatCurrencyConvert(calculatePerHrRateSuper) }} *
                  {{ totalHrOfWork.value }}h)</span>
                <span class="total_value">{{ formatCurrencyConvert(getSuperDeduction) }}</span>
              </div>
            </template>
            <template v-else>
              <div class="total_item result">
                <span class="total_text" v-if="isAustralia">Pay Rate <span v-if="billinAccountType !== 1"> Excluding Super</span></span>
                <span class="total_text" v-else>Pay Rate</span>
                <span class="total_value">{{ formatCurrencyConvert(excludingSuperPerHourRate) }}</span>
              </div>
              <div class="total_item result" v-if="isAustralia && billinAccountType !== 1">
                <span class="total_text">Total Super({{ formatCurrencyConvert(calculatePerHrRateSuper) }} * {{
                  totalHrOfWork.value }})</span>
                <span class="total_value">{{ formatCurrencyConvert(totalSuper) }}</span>
              </div>

            </template>
            <div class="total_item total_item result">
              <span class="total_text">Total shift hours</span>
              <span class="total_value">{{ formatDurationDisplay(shiftTotalTime) }}</span>
            </div>


            <div class="total_item" v-if="superEnable == 1 && !shift.shiftBookedAsInternalStaff">
              <span class="total_text">Total payout ({{ formattedRate }} * {{ totalHrOfWork.value }})</span>
              <span class="total_value">{{ getTotalPayOut }}</span>
            </div>





            <div class="total_item">
              <span class="total_text">Total travel compensation</span>
              <span class="total_value">{{ formatCurrencyConvert(shiftTravelCompensation) }} </span>
            </div>
            <div class="total_item">
              <span class="total_text">Sub total</span>
              <span class="total_value">{{ formatCurrencyConvert(getSubTotal) }} </span>
            </div>
            <div class="total_item" v-if="gstEnable == 1">
              <span class="total_text">GST(10%)</span>
              <span class="total_value"> {{ formatCurrencyConvert(getTotalGst) }} </span>
            </div>
            <template v-if="pharmacyApplyTransactionFees=== true">
              <div class="total_item" v-if="pharmacyPaynextDayFeeCalculation() !== '$0.00'">
                <span class="total_text" v-if="shiftSubscriptionExist && subscription">Transaction Fee @ {{transactionSubscriptionFee }}%</span>
                <span class="total_text" v-else-if="shiftSubscriptionExist">Transaction Fee @ {{transactionSubscriptionFee}}%</span>
                <span class="total_text" v-else-if="globalHidePNDTransaction == false && payNextDayEnabled">Transaction
                  Fee @ {{pharmacyPayNextDayFee }}%</span>
                <span class="total_value" v-if="globalHidePNDTransaction == false && payNextDayEnabled">{{ pharmacyPaynextDayFeeCalculation()}}</span>
                <span class="total_value" v-else-if="(shiftSubscriptionExist && subscription)">{{pharmacyPaynextDayFeeCalculation()}}</span>
                <span class="total_value" v-else-if="shiftSubscriptionExist">{{pharmacyPaynextDayFeeCalculation()}}</span>
              </div>

              <div v-if="pharmacyPayNextDayDiscountCalculation() !== '$0.00'">
                <div class="total_item"
                  v-if="(formsData.confirmForm.isPayNextDay.value == true || userRole == 'pharmacy') && payNextDayEnabled && globalHidePNDTransaction == false">
                  <span class="total_text">Transaction Fee Discount</span>
                  <span class="total_value">({{ pharmacyPayNextDayDiscountCalculation() }})</span>
                </div>
              </div>
            </template>
         
            

            <div class="total_item result">
              <span class="total_text">Total Remuneration</span>
              <span class="total_value">{{ shiftTotalCoast() }}</span>
            </div>
          </template>
          <template v-else>
            <div class="total_item total_item result">
              <span class="total_text">Total shift hours</span>
              <span class="total_value">{{ formatDurationDisplay(shiftTotalTime) }}</span>
            </div>
          </template>

        </div>
        <div class="total_wrapper" v-else>
          <template v-if="formsData.confirmForm.shiftBreak.active">
            <div class="total_item">
              <span class="total_text">Shift hours</span>
              <span class="total_value">{{ formatDurationDisplay(shiftTotalHours) }}</span>
            </div>
            <div class="total_item">
              <span class="total_text">Break time</span>
              <span class="total_value">-{{ formatDurationDisplay(shiftBreakHours) }}</span>
            </div>
          </template>
          <template v-else>
            <div class="total_item" v-if="canSeeLocumRates">
              <span class="total_text">Rate per hour</span>
              <span class="total_value">{{ formattedRate }}</span>
            </div>
            <div class="total_item">
              <span class="total_text">Shift hours</span>
              <span class="total_value">{{ formatDurationDisplay(shiftTotalHours) }}</span>
            </div>
            <div class="total_item">
              <span class="total_text">Break time</span>
              <span class="total_value">-0 m</span>
            </div>
          </template>

          <template v-if="superEnable == 1 && canSeeLocumRates">
            <div class="total_item result">
              <span class="total_text" v-if="isAustralia">Pay Rate Excluding Super</span>
              <span class="total_text" v-else>Pay Rate</span>
              <span class="total_value">{{ formatCurrencyConvert(excludingSuperPerHourRate) }}</span>
            </div>
            <div class="total_item result" v-if="isAustralia">
              <span class="total_text">Super ({{ formatCurrencyConvert(calculatePerHrRateSuper) }} *
                {{ totalHrOfWork.value }}h)</span>
              <span class="total_value">{{ formatCurrencyConvert(getSuperDeduction) }}</span>
            </div>
          </template>
        
          <div class="total_item result">
            <span class="total_text">Total Hours</span>
            <span class="total_value">{{ formatDurationDisplay(shiftTotalTime) }}</span>
          </div>
          <div class="total_item result" v-if="superEnable == 1 && canSeeLocumRates">
            <span class="total_text" v-if="isAustralia">Total Payable Excluding Super</span>
            <span class="total_text" v-else>Total Payable</span>
            <span class="total_value">{{ formatCurrencyConvert(totalPayableExcludingSuper) }}</span>
          </div>
          <!-- <div class="total_item result" v-if="superEnable != 1">
              <span class="total_text">Total Super</span>
              <span class="total_value">{{ formatCurrencyConvert(calculatePerHrRateSuper) }}</span>
          </div>
          <div class="total_item result" v-if="!shift.shiftBookedAsInternalStaff">
            <span class="total_text">Rate per hour<span v-if="superEnable != 1">({{formatCurrencyConvert(calculatePerHrRateSuper) }} + {{ formatCurrencyConvert(excludingSuperPerHourRate) }})</span></span>
            <span class="total_value">{{ formattedRate }}</span>
          </div> -->
          <!-- <div class="total_item" v-if="!shift.shiftBookedAsInternalStaff">
            <span class="total_text"
              >Total payout ({{ formattedRate }} * {{ totalHrOfWork.value }})</span
            >
            <span class="total_value">{{ getTotalPayOut }}</span>
          </div> -->


          <template v-if="canSeeLocumRates">
            <div class="total_item">
              <span class="total_text">Total travel compensation</span>
              <span class="total_value">{{ formatCurrencyConvert(shiftTravelCompensation) }} </span>
            </div>
            <div class="total_item">
              <span class="total_text">Sub total</span>
              <span class="total_value">{{ formatCurrencyConvert(getSubTotal) }} </span>
            </div>
            <div class="total_item" v-if="gstEnable == 1">
              <span class="total_text">GST(10%)</span>
              <span class="total_value"> {{ formatCurrencyConvert(getTotalGst) }} </span>
            </div>
            <div class="total_item"
              v-if="formsData.confirmForm.isPayNextDay.value == true && globalHidePNDTransaction == false">
              <span class="total_text">PayNextDay Fee @ {{ locumPayNextDayFee }}%</span>
              <span class="total_value">({{ locumPayNextDayFeeCalculation() }})</span>
            </div>
            <div class="total_item"
              v-if="formsData.confirmForm.isPayNextDay.value == true && globalHidePNDTransaction == false">
              <span class="total_text">PayNextDay Promotional Discount</span>
              <span class="total_value">{{
        locumPayNextDayDiscountCalculation()
      }}</span>
            </div>

            <div class="total_item result">
              <span class="total_text">Total Remuneration</span>
              <span class="total_value">{{ shiftTotalCoast() }}</span>
            </div>
          </template>
        </div>
      </div>
      <el-form-item class="button_submit mb0">
        <el-button class="submit_page w-100 mt-3" type="blue" @click="submit('confirmForm')"
          :disabled="formsData.confirmForm.disabled">
          Confirm Shift
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  </div>
  <modal-user-info :modalName="'userInfoModal'" :options="userInfoModal"></modal-user-info>
</template>

<script>
import moment from "moment";

import { ref, onMounted, inject, computed, reactive, watch, onBeforeMount } from "vue";

import { ElMessageBox } from "@/components/Vendor/Element";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
  IonDatetime,
  IonItem,
} from "@ionic/vue";

import { locumCanSeeShiftRates } from "@/helpers/utility/locumShiftRates";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import timeDiff from "@/helpers/date/timeDiff";
import store from "@/store/store";
import { UserInfoModal } from "@/modals/modals";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { formatAhpraDisplay } from "@/helpers/ahpra/ahpraDisplay.js";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    IonDatetime,
    IonItem,
    "modal-user-info": UserInfoModal,
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const $modals = inject("$modals");
    let user = $store.getters.GET_USER_DATA;
    const userRole = $store.getters.GET_USER_DATA.role;
    const payNextDayEnabled = ref(user.payNextDayEnabled);
    const userRoleReverse =
      $store.getters.GET_USER_DATA.role == "locum" ? "pharmacy" : "locum";
    const isAustralia = isAustraliaRegion();

    const shift = ref($route.params.shift);
    const canSeeLocumRates = computed(() => locumCanSeeShiftRates(shift.value, userRole));
    console.log("shift ref param", shift);
    const rate = shift.value.payRateExecSuper;
    const rateIncludingSuper = shift.value.payRate;
    const superRate = shift.value.payRateSuper ? shift.value.payRateSuper : 0;
    const shiftBreakTime = shift.value.userBreakMinutes ? shift.value.userBreakMinutes : 0;
    const shiftTravelCompensation = shift.value.travelCompensation;
    const locumPayNextDayDiscount = shift.value.locumPayNextDayDiscount ? shift.value.locumPayNextDayDiscount : 0;
    const locumPayNextDayFee = shift.value.locumPayNextDayFee ? shift.value.locumPayNextDayFee : 0;
    const pharmacyPayNextDayDiscount = shift.value.pharmacyPayNextDayDiscount ? shift.value.pharmacyPayNextDayDiscount : 0;
    const pharmacyPayNextDayFee = shift.value.pharmacyPayNextDayFee ? shift.value.pharmacyPayNextDayFee : 0;
    const pharmacyApplyTransactionFees = shift.value.applyTransactionFees ? shift.value.applyTransactionFees : false;
    const shiftSubscriptionExist = shift.value.subscriptionDetail
      ? shift.value.subscriptionDetail.subscriptionExists || shift.value.subscriptionDetail.groupSubscriptionExists
      : false;
    const superEnable = shift.value.locum.superEnable
      ? shift.value.locum.superEnable
      : 0;
    const gstEnable = shift.value.locum.gstEnable
      ? shift.value.locum.gstEnable
      : 0;
    const billinAccountType = shift.value.locum.billingAccountType
      ? shift.value.locum.billingAccountType
      : 0;
    const globalSuperCharge = process.env.VUE_APP_SUPER_CHARGE;
    const globalHidePNDTransaction = process.env.VUE_APP_HIDE_PND_TRANSACTION;
    console.log("🚀 ~ globalHidePNDTransaction:", globalHidePNDTransaction)
    const payNextDayEnable = ref(
      shift.value.paynextdayEnable != 0 ? true : false
    );
    const isBankVerified = ref(shift.value.locum.bankVerified == 1 ? 1 : 0);
    const checkPayNextDayForThisLocum = ref(
      shift.value.checkPayNextDayForThisLocum
        ? shift.value.checkPayNextDayForThisLocum
        : false
    );

    const messageIfCannotTakePartInPND = ref(
      shift.value.messageIfCannotTakePartInPnd
        ? shift.value.messageIfCannotTakePartInPnd
        : false
    );

    // const isBankVerified = ref(1);

    const subscription = ref(
      user.calculatedSubscriptions && user.calculatedSubscriptions.subscription
        ? user.calculatedSubscriptions.subscription
        : false
    );
    const transactionSubscriptionFee = ref(
      pharmacyTransactionFee()
    );
    const formattedRate = computed(() => {
      // Use Intl.NumberFormat to format the currency
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(rate);
    });
    function pharmacyTransactionFee() {
      if (shiftSubscriptionExist) {
        return shift.value.subscriptionDetail.transactionfeeInPercent
      } else {
        let fee = user.calculatedSubscriptions &&
          user.calculatedSubscriptions.transactionSubPrice
          ? user.calculatedSubscriptions.transactionSubPrice
          : 0
        return fee;
      }
    }

    function toMinutes(time) {
      let hours = parseInt(time.split(":")[0]);
      return parseInt(time.split(":")[1]) + hours * 60;
    }

    const diffTime = (start, end) => {
      start = moment(start, "HH:mm");
      end = moment(end, "HH:mm");

      return timeDiff(start, end);
    };

    watch(isBankVerified, (newValue) => {
      if (newValue === 0) {
        payNextDayEnable.value = false;
        formsData.confirmForm.isPayNextDay.value = false;
      }
    });

    const formsDataArray = reactive({
      confirmForm: {
        shiftTime: {
          value: {
            timeStart: moment(
              shift.value.userStartTime || shift.value.startTime,
              ["h:mm A"]
            ).format(),
            timeEnd: moment(shift.value.userEndTime || shift.value.endTime, [
              "h:mm A",
            ]).format(),
          },
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "timeRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        shiftBreak: {
          value: {
            hours: "0",
            minutes: "0",
          },
          time: shiftBreakTime
            ? moment(
              Math.floor(shiftBreakTime / 60) + ":" + (shiftBreakTime % 60),
              ["h:m"]
            ).format("HH:mm")
            : "00:00",
          hoursValue: () => {
            let startHours = parseInt(
              moment(formsData.confirmForm.shiftTime.value.timeStart).format(
                "H"
              )
            );
            let endHours = parseInt(
              moment(formsData.confirmForm.shiftTime.value.timeEnd).format("H")
            );
            let shiftBreakHours = [];
            if (endHours - startHours < 0) {
              formsData.confirmForm.shiftBreak.time = "00:00";
            } else {
              shiftBreakHours = [...Array(endHours - startHours).keys()];
            }
            return shiftBreakHours;
          },
          active: false,
        },
        isPayNextDay: {
          value: payNextDayEnable.value ? true : false,
        },
      },
    });

    const shiftBreakChange = (e) => {
      let [hours, minutes] = e.detail.value.split(":");
      formsData.confirmForm.shiftBreak.value.hours = hours;
      formsData.confirmForm.shiftBreak.value.minutes = minutes;
    };

    const userInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const userInfoModalOpen = (user) => {
      userInfoModal.value.user = user;
      $modals.open("userInfoModal");
    };

    const goBack = () => {
      $router.push({
        name: "calendar",
        params: {
          date: shift.value.date,
        },
      });
    };

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              {
                await ElMessageBox.confirm(
                  ``,
                  "Are you sure you want to confirm this shift?",
                  {
                    distinguishCancelAndClose: true,
                    showConfirmButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--green",
                    cancelButtonClass: "el-button--grey",
                    showClose: true,
                  }
                );
              }
              if (userRole == "locum") {
                let req = {
                  shiftId: shift.value.id,
                  params: {
                    break_minutes: formsData.confirmForm.shiftBreak.active
                      ? toMinutes(
                        moment(shiftBreakHours.value, "H.mm").format("HH:mm")
                      )
                      : 0,
                    start_time: moment(
                      formsData.confirmForm.shiftTime.value.timeStart
                    ).format("HH:mm"),
                    end_time: moment(
                      formsData.confirmForm.shiftTime.value.timeEnd
                    ).format("HH:mm"),
                    paynextday_enable: formsData.confirmForm.isPayNextDay.value,
                  },
                };
                console.log(req);
                await $store.dispatch("CONFIRM_SHIFT", req);
              } else {
                await $store.dispatch("VIRIFY_SHIFT", {
                  shiftId: shift.value.id,
                });
              }

              await ElMessageBox.confirm(
                `${userRole === "locum"
                  ? `You can now leave the admin work to us! We will start the ${isAustralia.value ? "invoicing" : "payroll"
                  } process once the timesheet is approved by the Pharmacy.`
                  : " "
                }`,
                `${userRole === "locum"
                  ? "Timesheet Submitted"
                  : "Timesheet Approved"
                }`,
                {
                  showCancelButton: false,
                  confirmButtonText: "Close",
                  confirmButtonClass: "el-button--grey",
                  showClose: false,
                  type: "success",
                  customClass: "modal_success success",
                  callback: () => {
                    $router.push({
                      name: "shift_rating",
                      params: {
                        shiftId: shift.value.id,
                      },
                    });
                  },
                }
              );
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_shift_page");
      setFormRefs();
      if (checkPayNextDayForThisLocum.value == false) {
        formsData.confirmForm.isPayNextDay.value = false;
      }

      if (userRole == "pharmacy" && payNextDayEnable.value == 0) {
        formsData.confirmForm.isPayNextDay.value = false;
      }

      if (
        userRole == "locum" &&
        (payNextDayEnable.value == 0 || payNextDayEnable.value == null)
      ) {
        if (checkPayNextDayForThisLocum.value == false) {
          formsData.confirmForm.isPayNextDay.value = false;
        } else {
          formsData.confirmForm.isPayNextDay.value = true;
        }
      } else {
        formsData.confirmForm.isPayNextDay.value = false;
      }

    });

    const shiftTotalHours = computed(() => {
      return diffTime(
        moment(formsData.confirmForm.shiftTime.value.timeStart).format("HH:mm"),
        moment(formsData.confirmForm.shiftTime.value.timeEnd).format("HH:mm")
      );
    });
    const shiftBreakHours = computed(() => {
      return moment(formsData.confirmForm.shiftBreak.time, "HH:mm").format(
        "H.mm"
      );
    });
    const shiftTotalTime = computed(() => {
      if (userRole === "locum") {
        if (formsData.confirmForm.shiftBreak.active) {
          return diffTime(
            formsData.confirmForm.shiftBreak.time,
            moment(shiftTotalHours.value, "H.mm").format("HH:mm")
          );
        } else {
          return diffTime(
            moment(formsData.confirmForm.shiftTime.value.timeStart).format(
              "HH:mm"
            ),
            moment(formsData.confirmForm.shiftTime.value.timeEnd).format(
              "HH:mm"
            )
          );
        }
      } else {
        return diffTime(
          formsData.confirmForm.shiftBreak.time,
          moment(shiftTotalHours.value, "H.mm").format("HH:mm")
        );
      }
    });

    const shiftTotalCoast = () => {
      let sum = 0;
      if (userRole == "pharmacy") {
        sum =
          totalCalculationCost() + pharmacyFeeOnly() - pharmacyDiscountOnly();
      } else {
        sum =
          totalCalculationCost() -
          locumFeeCalculationOnly() +
          locumateDiscountCalculationOnly();
        console.log("total sum of files", sum);
      }

      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(sum);
    };

    const calculatePerHrRateSuper = computed(() => {
      // console.log("rate", rate);
      // const result = rate - rate / globalSuperCharge;
      // const totalResult = result.toFixed(2);
      // const parsedResult = parseFloat(totalResult);
      return superRate;
    });

    const totalSuper = computed(() => {
      let totalSuperRate = calculatePerHrRateSuper.value * totalHrOfWork.value.value;

      totalSuperRate = totalSuperRate.toFixed(2);
      return parseFloat(totalSuperRate);
    })

    const excludingSuperPerHourRate = computed(() => {
      let rateExcludingSuper = 0;
      if (billinAccountType === 1) {
        rateExcludingSuper = rateIncludingSuper.toFixed(2);
        return parseFloat(rateExcludingSuper);
      } else {
        rateExcludingSuper = rateIncludingSuper - superRate;
        rateExcludingSuper = rateExcludingSuper.toFixed(2);
        return parseFloat(rateExcludingSuper);
      }
    })

    const totalPayableExcludingSuper = computed(() => {
      let tpayableExecSuper = excludingSuperPerHourRate.value * totalHrOfWork.value.value
      tpayableExecSuper = tpayableExecSuper.toFixed(2);
      return parseFloat(tpayableExecSuper);

    })
    const getTotalPayOut = computed(() => {
      console.log("rate payout", rate);
      const payoutCal = rate * totalHrOfWork.value.value;
      console.log("payout", payoutCal);
      const payoutDec = payoutCal.toFixed(2);
      const parsePayout = parseFloat(payoutDec);
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(parsePayout);
    });

    const formatCurrencyConvert = (value) => {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(value);
    };

    const formatDurationDisplay = (value) => {
      const raw = value === null || value === undefined ? "" : String(value);
      let hours = 0;
      let minutes = 0;

      if (raw.includes(":")) {
        const [hourPart, minutePart] = raw.split(":");
        hours = parseInt(hourPart, 10) || 0;
        minutes = parseInt(minutePart, 10) || 0;
      } else if (raw.includes(".")) {
        const [hourPart, minutePart] = raw.split(".");
        hours = parseInt(hourPart, 10) || 0;
        minutes = parseInt(minutePart, 10) || 0;
      } else {
        hours = parseInt(raw, 10) || 0;
      }

      if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}m`;
      }
      if (hours > 0) {
        return `${hours}h`;
      }
      return `${minutes} m`;
    };

    const calculatePerHrRateWithoutSuper = computed(() => {
      // console.log("hello rate", shift.value.locum.superEnable);
      // if (shift.value.locum.superEnable == 1) {
      //   const result = rate / globalSuperCharge;
      //   const totalResult = result.toFixed(2);
      //   const parsedResult = parseFloat(totalResult);
      //   console.log("without super", parsedResult);
      //   return parsedResult;
      // } else {
      //   return shift.value.payRateExecSuper;
      // }
      return shift.value.payRateExecSuper;
    });

    const calculatePerHrSuper = computed(() => {
      return shift.value.payRateSuper;
    });

    const getTotalGst = computed(() => {
      if (shift.value.locum.gstEnable == 1) {
        if (shift.value.locum.billingAccountType == 2) {
          // const payRateAfterSuper = calculatePerHrRateSuper() * totalHrOfWork();
          console.log("hhhh", calculatePerHrRateWithoutSuper.value);
          const amount =
            calculatePerHrRateWithoutSuper.value * totalHrOfWork.value.value;
          const gstAmount = (amount + shift.value.travelCompensation) * 0.1;
          const gstAmountTotal = gstAmount.toFixed(2);
          const parsedGstTotal = parseFloat(gstAmountTotal);
          return parsedGstTotal;
        } else {
          const amount = shift.value.payRateExecSuper * totalHrOfWork.value.value;
          const gstAmount = ((amount + shift.value.travelCompensation) * 10) / 100;
          const gstAmountTotal = gstAmount.toFixed(2);
          const parsedGstTotal = parseFloat(gstAmountTotal);
          return parsedGstTotal;
        }
      } else {
        return 0;
      }
    });

    const getSuperDeduction = computed(() => {
      const payRateAfterSuper =
        calculatePerHrRateSuper.value * totalHrOfWork.value.value;
      const payRateAmount = payRateAfterSuper.toFixed(2);
      const parsedTotalPaySuper = parseFloat(payRateAmount);
      return parsedTotalPaySuper;
    });

    const getTotalAmount = computed(() => {
      if (shift.value.locum.superEnable == 1) {
        console.log(
          "total amount db",
          shift.value.payRateExecSuper * totalHrOfWork.value.value
        );
        console.log("total amount ug", totalHrOfWork.value.value);
        console.log(
          "total amount dbug",
          calculatePerHrRateWithoutSuper.value * totalHrOfWork.value.value
        );
        const amount = calculatePerHrRateWithoutSuper.value * totalHrOfWork.value.value;
        const total = amount.toFixed(2);
        const parsedTotal = parseFloat(total);
        return parsedTotal;
      } else {
        const amount = shift.value.payRateExecSuper * totalHrOfWork.value.value;
        const total = amount.toFixed(2);
        const parsedTotal = parseFloat(total);
        return parsedTotal;
      }
    });

    const getSubTotal = computed(() => {
      if (shift.value.locum.superEnable == 1) {
        console.log(
          "total amount db",
          shift.value.payRateExecSuper * totalHrOfWork.value.value
        );
        console.log("total amount ug", totalHrOfWork.value.value);
        console.log(
          "total amount dbug",
          calculatePerHrRateWithoutSuper.value * totalHrOfWork.value.value
        );
        const amount =
          calculatePerHrRateWithoutSuper.value * totalHrOfWork.value.value +
          shift.value.travelCompensation;
        const total = amount.toFixed(2);
        const parsedTotal = parseFloat(total);
        return parsedTotal;
      } else {
        const amount =
          shift.value.payRateExecSuper * totalHrOfWork.value.value +
          shift.value.travelCompensation;
        const total = amount.toFixed(2);
        const parsedTotal = parseFloat(total);
        return parsedTotal;
      }
    });

    const totalHrOfWork = computed(() => {
      const arr = shiftTotalTime.value.toString().split(":");
      let minutes = arr[1];
      // if (userRole === "pharmacy") {
      //    minutes = arr[1] - shiftBreakTime;
      //   if(shiftBreakTime > arr[1]){
      //     const totalMinute = parseFloat(parseFloat(arr[0] * 60) + parseFloat(arr[1]));
      //     const totalMinuteMinusBreak = totalMinute - shiftBreakTime;
      //     const shifBreakHour = totalMinuteMinusBreak/60;
      //     const shifBreakHourInt = parseInt(shifBreakHour);
      //     const shiftBreakMinute = (shifBreakHour - shifBreakHourInt) * 60;
      //     arr[0] = shifBreakHour;
      //     minutes = shiftBreakMinute

      //   }
      // }
      const dec = parseInt((minutes / 6) * 10, 10);
      const calculateTime = computed(() => {
        return parseFloat(
          parseInt(arr[0], 10) + "." + (dec < 10 ? "0" : "") + dec
        );
      });
      console.log('whhyt', calculateTime)
      return calculateTime;
    });

    const totalCalculationCost = () => {
      // const arr = shiftTotalTime.value.toString().split(':')
      // const dec = parseInt((arr[1]/6)*10, 10);
      // const calculateTime = computed(() => {
      //   return parseFloat(parseInt(arr[0], 10) + '.' + (dec<10?'0':'') + dec);
      // })
      console.log("total amount", getTotalAmount.value);
      console.log("total travel", shift.value.travelCompensation);
      console.log("gst", getTotalGst.value);
      if (shift.value.locum.gstEnable == 1) {
        const sum =
          getTotalAmount.value +
          shift.value.travelCompensation +
          getTotalGst.value;
        const totalSum = sum.toFixed(2);
        const parsedSum = parseFloat(totalSum);
        return parsedSum;
      } else {
        const sum = getTotalAmount.value + shift.value.travelCompensation;
        const totalSum = sum.toFixed(2);
        const parsedSum = parseFloat(totalSum);
        return parsedSum;
      }
    };

    const locumFeeCalculationOnly = () => {
      // if(typeof(locumPayNextDayFee) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true) {
        const totalCost = totalCalculationCost();
        const fee = totalCost * (locumPayNextDayFee / 100);
        const fixTwo = fee.toFixed(2);
        const parsedFee = parseFloat(fixTwo);
        return parsedFee;
      } else {
        return 0;
      }
    };

    const locumPayNextDayFeeCalculation = () => {
      // if(typeof(locumPayNextDayFee) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true) {
        const totalCost = locumFeeCalculationOnly();
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(totalCost);
      } else {
        return null;
      }
    };

    const locumateDiscountCalculationOnly = () => {
      // if(typeof(locumPayNextDayDiscount) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true) {
        const totalCost = totalCalculationCost();
        const discount = totalCost * (locumPayNextDayDiscount / 100);
        const fixTwo = discount.toFixed(2);
        const parsedDiscount = parseFloat(fixTwo);
        return parsedDiscount;
      } else {
        return 0;
      }
    };

    const locumPayNextDayDiscountCalculation = () => {
      // if(typeof(locumPayNextDayDiscount) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true) {
        const totalCost = locumateDiscountCalculationOnly();
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(totalCost);
      } else {
        return null;
      }
    };

    const pharmacyFeeOnly = () => {
      // if(typeof(pharmacyPayNextDayFee) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true || userRole == "pharmacy") {
        const totalCost = totalCalculationCost();
        let fee = 0;
        if(pharmacyApplyTransactionFees === true){
          if (shiftSubscriptionExist && subscription.value) {
            fee = totalCost * (transactionSubscriptionFee.value / 100);
          } else if (shiftSubscriptionExist) {
            fee = totalCost * (transactionSubscriptionFee.value / 100);
          } else if (payNextDayEnabled.value) {
            fee = totalCost * (pharmacyPayNextDayFee / 100);
          } else {
            fee = 0;
          }
          const fixTwo = fee.toFixed(2);
          const parsedPhFee = parseFloat(fixTwo);
          return parsedPhFee;
        }else{
          return 0;
        }
      } else {
        return 0;
      }
    };

    const pharmacyPaynextDayFeeCalculation = () => {
      // if(typeof(pharmacyPayNextDayFee) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true || userRole == "pharmacy") {
        const totalCost = pharmacyFeeOnly();
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(totalCost);
      } else {
        return null;
      }
    };

    const pharmacyDiscountOnly = () => {
      // if(typeof(pharmacyPayNextDayDiscount) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true || userRole == "pharmacy") {
        const totalCost = totalCalculationCost();
        let discountfee = 0;

       

        if(pharmacyApplyTransactionFees === true){
          if (shiftSubscriptionExist && subscription.value) {
            discountfee = totalCost * (shift.value.subscriptionDetail.discountfeeInPercent / 100);
          } else if (shiftSubscriptionExist) {
            discountfee = totalCost * (shift.value.subscriptionDetail.discountfeeInPercent / 100);
          } else {
            discountfee = totalCost * (pharmacyPayNextDayDiscount / 100);
          }
          const discount = discountfee;
          const fixTwo = discount.toFixed(2);
          const parsedPhDiscount = parseFloat(fixTwo);
          return parsedPhDiscount;

        }else{
          return 0;
        }
      } else {
        return 0;
      }
    };

    const pharmacyPayNextDayDiscountCalculation = () => {
      // if(typeof(pharmacyPayNextDayDiscount) !== 'undefined'){
      if (formsData.confirmForm.isPayNextDay.value == true || userRole == "pharmacy") {
        const totalCost = pharmacyDiscountOnly();
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(totalCost);
      } else {
        return null;
      }
    };

    onBeforeMount(async () => {
      try {
        await store.dispatch("SET_CURRENT_USER_DATA", {
          with: "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
        });
        const refreshData = $store.getters.GET_USER_DATA;
        console.log("allowow", refreshData);
        payNextDayEnabled.value = refreshData.payNextDayEnabled; // Update the userData reactive property
        if (payNextDayEnabled.value && checkPayNextDayForThisLocum.value == true) {
          formsData.confirmForm.isPayNextDay.value = true;
        } else {
          formsData.confirmForm.isPayNextDay.value = false;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    });

    const {
      onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      goBack,
      submit,
      shiftBreakChange,
      userRole,
      userRoleReverse,
      shift,
      shiftTotalHours,
      shiftBreakHours,
      shiftTotalTime,
      rate,
      userInfoModalOpen,
      userInfoModal,
      formatAhpraDisplay,
      shiftTravelCompensation,
      shiftTotalCoast,
      locumPayNextDayDiscount,
      locumPayNextDayFee,
      locumPayNextDayFeeCalculation,
      totalCalculationCost,
      locumPayNextDayDiscountCalculation,
      pharmacyPayNextDayDiscount,
      pharmacyPayNextDayFee,
      pharmacyPaynextDayFeeCalculation,
      pharmacyPayNextDayDiscountCalculation,
      locumFeeCalculationOnly,
      locumateDiscountCalculationOnly,
      pharmacyFeeOnly,
      pharmacyDiscountOnly,
      shiftSubscriptionExist,
      user,
      calculatePerHrRateSuper,
      calculatePerHrRateWithoutSuper,
      superEnable,
      gstEnable,
      billinAccountType,
      totalHrOfWork,
      getTotalGst,
      getSuperDeduction,
      getTotalAmount,
      getSubTotal,
      getTotalPayOut,
      globalSuperCharge,
      payNextDayEnable,
      isBankVerified,
      subscription,
      transactionSubscriptionFee,
      checkPayNextDayForThisLocum,
      messageIfCannotTakePartInPND,
      payNextDayEnabled,
      superRate,
      calculatePerHrSuper,
      formattedRate,
      formatCurrencyConvert,
      formatDurationDisplay,
      globalHidePNDTransaction,
      excludingSuperPerHourRate,
      rateIncludingSuper,
      totalSuper,
      totalPayableExcludingSuper,
      pharmacyApplyTransactionFees,
      isAustralia,
      canSeeLocumRates,
    };
  },
};
</script>
